import React from 'react';
import ReportingDashboardPage from '../components/ReportingDashboardPage';

const ReportingDashboardApp = (props) => (
  <ReportingDashboardPage {...props} />
);

export default ReportingDashboardApp;
